import { useState } from "react";
import { genderOptions } from "../../../helpers/selectOptions";

export const demographicsSelectOptions = (appData) => {
  const {
    demographicsOptions: {
      nationalities: nationalityOptions,
      sexualOrientations: sexualOrientationOptions,
      ethnicities: ethnicityOptions,
    },
  } = appData;

  return {
    nationalityOptions,
    sexualOrientationOptions,
    ethnicityOptions,
    genderOptions,
  };
};

export const demographicsConstraints = {
  nationalityCode: {
    presence: {
      allowEmpty: false,
      message: "^Please select your nationality",
    },
  },
  sexualOrientationCode: {
    presence: {
      allowEmpty: false,
      message: "^Please select your sexual orientation",
    },
  },
  gender: {
    presence: {
      allowEmpty: false,
      message: "^Please select your sex",
    },
  },
  ethnicityCode: {
    presence: {
      allowEmpty: false,
      message: "^Please select your ethnicity",
    },
  },
};

export const useDemographicsState = ({
  nationalityCode = "",
  gender = "",
  ethnicityCode = "",
  sexualOrientationCode = "",
}) => {
  const initialState = {
    nationalityCode,
    gender,
    ethnicityCode,
    sexualOrientationCode,
  };

  const [demographicsState, setDemographicsState] = useState(initialState);

  const [demographicsErrors, setDemographicsErrors] = useState({});

  const handleDemographicsState = (key, val) => {
    if (val !== "") {
      setDemographicsErrors({
        ...demographicsErrors,
        [key]: undefined,
      });
    }
    return setDemographicsState({
      ...demographicsState,
      [key]: val,
    });
  };
  return [
    demographicsState,
    handleDemographicsState,
    demographicsErrors,
    setDemographicsErrors,
  ];
};
